import ActivatePage from '@/auth/activate/ActivatePage.vue';
import AuthContainer from '@/auth/auth-container/AuthContainer.vue';
import EmailVerification from '@/auth/email-verification/EmailVerification.vue';
import EmailVerificationConfirm from '@/auth/email-verification/EmailVerificationConfirm.vue';
import LoginPage from '@/auth/login/LoginPage.vue';
import PasswordReset from '@/auth/password-reset/PasswordReset.vue';
import PasswordResetConfirm from '@/auth/password-reset-confirm/PasswordResetConfirm.vue';
import PasswordResetRequested from '@/auth/password-reset/PasswordResetRequested.vue';
import SignupPage from '@/auth/signup/SignupPage.vue';

import RedirectPage from '@/auth/redirect/RedirectPage.vue';
import authGuards from '@/auth/guards/auth.guards';

export default [
  {
    path: '/auth',
    component: AuthContainer,
    redirect: {
      name: 'login',
    },
    children: [
      {
        path: '/activate',
        name: 'activate',
        component: ActivatePage,
        meta: {
          guards: [
            authGuards.isNotAuthenticated,
          ],
          title: 'Activate',
        },
      },
      {
        path: '/email-verification',
        name: 'email-verification',
        component: EmailVerification,
        meta: {
          guards: [
            authGuards.isAuthenticated,
            authGuards.isNotConfirmed,
            authGuards.hasNoVendor,
          ],
          title: 'Verify your email',
        },
      },
      {
        path: '/email-verification-confirm',
        name: 'email-verification-confirm',
        component: EmailVerificationConfirm,
        meta: {
          title: 'Verifying your email',
        },
      },
      {
        path: '/login',
        name: 'login',
        component: LoginPage,
        meta: {
          guards: [
            authGuards.isNotAuthenticated,
          ],
          title: 'Login',
        },
      },
      {
        path: '/password-reset',
        name: 'password-reset',
        component: PasswordReset,
        meta: {
          guards: [
            authGuards.isNotAuthenticated,
          ],
          title: 'Password reset',
        },
      },
      {
        path: '/password-reset-requested',
        name: 'password-reset-requested',
        component: PasswordResetRequested,
        props: true,
        meta: {
          guards: [
            authGuards.isNotAuthenticated,
          ],
          title: 'Password reset',
        },
      },
      {
        path: '/password-reset-confirm',
        name: 'password-reset-confirm',
        component: PasswordResetConfirm,
        meta: {
          guards: [
            authGuards.isNotAuthenticated,
          ],
          title: 'Confirm new password',
        },
      },
      {
        path: '/signup',
        name: 'signup',
        component: SignupPage,
        meta: {
          guards: [
            authGuards.isNotAuthenticated,
          ],
          title: 'Signup',
        },
      },
    ],
  },
  {
    path: '/',
    name: 'redirect',
    component: RedirectPage,
    meta: {
      guards: [
        authGuards.isAuthenticated,
      ],
      title: 'Redirecting',
    },
  },
];
